import { Link } from "@tanstack/react-router";
import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/Button";

export function NotFoundPage() {
	return (
		<div className="min-h-screen bg-background flex items-center justify-center px-4">
			<div className="text-center max-w-md">
				<div className="mb-6 text-text-muted" aria-hidden="true">
					<FileQuestion size={64} className="mx-auto" />
				</div>
				<h1 className="text-4xl font-bold text-text mb-2">404</h1>
				<h2 className="text-xl font-semibold text-text mb-4">Seite nicht gefunden</h2>
				<p className="text-text-secondary mb-8">
					Die angeforderte Seite existiert nicht oder wurde verschoben.
				</p>
				<Link to="/search">
					<Button variant="primary">Zur Startseite</Button>
				</Link>
			</div>
		</div>
	);
}
